// @flow
import React from 'react';
import { Form, Modal, Message, Header, Input, Button } from 'semantic-ui-react';
import Link from 'shared/components/Link';
import Http from 'react/utils/http';
import LoginUtil from './LoginUtil';
import ThemeUtils from 'shared/utils/ThemeUtils';

type Props = {
  email: string,
  onEmailInputChange: (evt: SyntheticEvent<Input>, data: { value: string }) => void,
  onPasswordResetEmailSent: () => void
};

type State = {
  isModalOpen: boolean,
  isSendingEmail: boolean,
  error: ?string
};

const FORM_ID = 'login-page-forgot-password-modal-form';

export default class ForgotPasswordLink extends React.PureComponent<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      isModalOpen: false,
      isSendingEmail: false,
      error: undefined
    };
  }

  inputRef: ?Input = undefined;

  openModal = () => {
    this.setState({isModalOpen: true, error: undefined}, () => {
      focusOn(this.inputRef);
    });
  };

  closeModal = () => {
    if (!this.state.isSendingEmail) {
      this.setState({isModalOpen: false, error: undefined});
    }
  };

  submit = () => {
    const emailError = LoginUtil.getEmailError(this.props.email);
    if (emailError) {
      this.setState({error: emailError});
      focusOn(this.inputRef);
      return;
    }

    this.setState({error: undefined, isSendingEmail: true});
    Http.post(`/api/users/v1/reset/request/${this.props.email}`, {}, {forceCallback: true}, (data, errmsg) => {
      this.setState({isSendingEmail: false});
      if (errmsg) {
        this.setState({error: errmsg});
      } else {
        this.setState({isModalOpen: false, error: undefined});
        this.props.onPasswordResetEmailSent();
      }
    });
  };

  render() {
    return (
      <Modal
        className={ThemeUtils.getCustomStyleClassForDomain("login-page-forgot-password-modal")}
        trigger={
          <div>
            <Link
              href=""
            >Forgot password?</Link></div>}
        open={this.state.isModalOpen}
        onOpen={this.openModal}
        onClose={this.closeModal}
        size="mini"
      >
        <Modal.Content>
          {
            this.state.error
            && <Message error content={this.state.error}/>
          }
          <Form id={FORM_ID} onSubmit={this.submit}>
            <Header
              content="Send password reset email to:"/>
            <Input
              ref={(elem) => {
                this.inputRef = elem;
              }}
              fluid
              value={this.props.email}
              disabled={this.state.isSendingEmail}
              onChange={this.props.onEmailInputChange}

            />
          </Form>
        </Modal.Content>
        <Modal.Actions>
          <Button
            content="Cancel"
            disabled={this.state.isSendingEmail}
            onClick={this.closeModal}
          />
          <Button
            primary
            type="submit"
            form={FORM_ID}
            content="&nbsp;Send&nbsp;"
            disabled={this.state.isSendingEmail}
            loading={this.state.isSendingEmail}
          />
        </Modal.Actions>
      </Modal>
    );
  }
}

const focusOn = (inputRef: ?Input) => {
  if (inputRef) {
    inputRef.focus();
  }
};
